import React from 'react'

export default function KeyValueList({ items = [], logo }) {
  const visibleItems = items.filter(({ value }) => value)

  return (
    <div className="flex flex-col md:flex-row gap-6">
      {logo && <div className="shrink-0">{logo}</div>}

      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6 w-full">
        {
          visibleItems.map(({ label, value }) => (
            <div key={label}>
              <dt className="text-xs text-secondary">{label}</dt>
              <dd className="text-sm font-medium text-dark-blue">{value}</dd>
            </div>
          ))
        }
      </dl>
    </div>
  )
}
